export type CommunicationDirection = 'inbound' | 'outbound' | 'all';

interface logScaleEntityPivotPops {
  start: number;
  end: number;
  entityName: string;
  direction?: CommunicationDirection;
}

export const logScaleEntityPivot = ({
  start,
  end,
  entityName,
  direction = 'all',
}: logScaleEntityPivotPops) => {
  // Build query based on direction
  let query = '';
  switch (direction) {
    case 'inbound':
      // Show connections where others contacted this entity (entity is responder)
      query = `id.resp_h%3D${entityName}`;
      break;
    case 'outbound':
      // Show connections where this entity contacted others (entity is originator)
      query = `id.orig_h%3D${entityName}`;
      break;
    case 'all':
    default:
      // Show all connections involving this entity
      query = `id.orig_h%3D${entityName}%20or%20id.resp_h%3D${entityName}%20or%20src%3D${entityName}`;
      break;
  }

  return `query=${query}&live=false&humioStart=${
    start && (start - 330) * 1000
  }&humioEnd=${
    end && (end + 330) * 1000
  }&fullscreen=false&widgetType=table-view&showOnlyFirstLine=false&start=${start}&end=${end}`;
};
